// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_title__rvGVb {
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  font-weight: 600;
  color: #18316e;
}

.styles_content__Pv0mE {
  padding: 1.5rem !important;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.styles_field__cjG2w {
  width: 100%;
  margin-bottom: 0.5rem;
}

.styles_periodRow__xOPlU {
  display: flex;
  gap: 1rem;
  width: 100%;
}

.styles_periodField__gX9c5 {
  flex: 1 1;
}

.styles_containerBtn__ZU3CN {
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.styles_btnCancelar__GASvH {
  background-color: #6c757d !important;
  color: white !important;
  text-transform: none !important;
}

.styles_btnSalvar__mFGIh {
  background-color: #18316e !important;
  color: white !important;
  text-transform: none !important;
}

.styles_btnSalvar__mFGIh:hover {
  background-color: #1a3a7e !important;
}

.styles_btnCancelar__GASvH:hover {
  background-color: #5a6268 !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/PreviaINSS/ModalNovaPrevia/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":[".title {\n  display: flex;\n  align-items: center;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #18316e;\n}\n\n.content {\n  padding: 1.5rem !important;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.field {\n  width: 100%;\n  margin-bottom: 0.5rem;\n}\n\n.periodRow {\n  display: flex;\n  gap: 1rem;\n  width: 100%;\n}\n\n.periodField {\n  flex: 1;\n}\n\n.containerBtn {\n  padding: 1rem 1.5rem;\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n}\n\n.btnCancelar {\n  background-color: #6c757d !important;\n  color: white !important;\n  text-transform: none !important;\n}\n\n.btnSalvar {\n  background-color: #18316e !important;\n  color: white !important;\n  text-transform: none !important;\n}\n\n.btnSalvar:hover {\n  background-color: #1a3a7e !important;\n}\n\n.btnCancelar:hover {\n  background-color: #5a6268 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `styles_title__rvGVb`,
	"content": `styles_content__Pv0mE`,
	"field": `styles_field__cjG2w`,
	"periodRow": `styles_periodRow__xOPlU`,
	"periodField": `styles_periodField__gX9c5`,
	"containerBtn": `styles_containerBtn__ZU3CN`,
	"btnCancelar": `styles_btnCancelar__GASvH`,
	"btnSalvar": `styles_btnSalvar__mFGIh`
};
export default ___CSS_LOADER_EXPORT___;
